import { defineNuxtPlugin, useNuxtApp, useRuntimeConfig } from '#app'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.provide('appTitle', 'Loop Letters')
}) 